import { createClient } from "@supabase/supabase-js";
import { createTimedFetch } from "./utils/timedFetch";
import { pickAuthStorageKey } from "./utils/authStorageKey";

// Falls back to this project's own values so nothing breaks with no .env
// set up — but reads from the environment first, so a staging deploy (or
// anyone running this locally against a test project) can point elsewhere
// via .env.local without ever touching this file or committing a change
// that would send local testing at the live production database.
const supabaseUrl =
  process.env.REACT_APP_SUPABASE_URL || "https://mbqeyvnvsvlzmjzldovb.supabase.co";
const supabaseAnonKey =
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1icWV5dm52c3Zsem1qemxkb3ZiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg0MDU4MjEsImV4cCI6MjA5Mzk4MTgyMX0.s2olTRyIBmMNoArM5TNkSPS-s_T82KbSG9ibXhn0AOM";

// Where supabase-js keeps the login. The installed Android app gets its own (see
// utils/authStorageKey.js for why); everywhere else it is supabase-js's usual one.
const defaultAuthStorageKey = `sb-${new URL(supabaseUrl).hostname.split(".")[0]}-auth-token`;
export const authStorageKey = pickAuthStorageKey(defaultAuthStorageKey, {
  standalone:
    typeof window !== "undefined" &&
    (window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true),
  userAgent: typeof navigator !== "undefined" ? navigator.userAgent : ""
});

export const supabase = createClient(
  supabaseUrl,
  supabaseAnonKey,
  { auth: { storageKey: authStorageKey }, global: { fetch: createTimedFetch() } }
);

// Who the browser last saw logged in, read straight from where supabase-js
// keeps the session — no waiting on the client. supabase.auth.getSession()
// can take seconds at startup (it queues behind a token refresh, or behind
// another tab / the installed app holding the auth lock), and until it
// answers a page starting from `null` shows its logged-out UI to someone who
// is in fact logged in. Pages start from this as their first guess and
// still let getSession() have the final say.
export function getStoredUser() {
  try {
    const raw = localStorage.getItem(authStorageKey);
    return raw ? JSON.parse(raw)?.user ?? null : null;
  } catch {
    return null;
  }
}
